import { render, staticRenderFns } from "./Vmc35Anniversary2024.vue?vue&type=template&id=23740941&scoped=true"
import script from "./Vmc35Anniversary2024.vue?vue&type=script&lang=js"
export * from "./Vmc35Anniversary2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23740941",
  null
  
)

export default component.exports